/**
 * 透かしの見え方をブラウザ上で再現する。
 *
 * 実際の焼き込みはコンテナの ffmpeg が行うが、設定を変えるたびに
 * 素材を作り直して確認するのは現実的でない。位置・大きさ・不透明度の
 * 計算式を ffmpeg 側と揃えて、その場で見えるようにする。
 *
 * **あくまで近似**。フォントが違う（画面はシステムフォント、焼き込みは
 * Noto Sans CJK）ため、字形と幅は完全には一致しない。
 */
export function WatermarkPreview({
  label,
  position,
  fontScale,
  opacity,
  boxEnabled,
  boxOpacity,
}: {
  label: string
  position: string
  fontScale: number
  opacity: number
  boxEnabled: boolean
  boxOpacity: number
}) {
  const [v, h] = position.split('-')
  // ffmpeg 側と同じ「高さの2%」を余白にする
  const margin = '2%'

  const style: React.CSSProperties = {
    position: 'absolute',
    // ffmpeg は fontsize=h*scale で描く。**枠の高さに対する比率**なので、
    // % （＝親の font-size 基準）ではなく cqh（コンテナの高さ基準）を使う。
    // ここを % にすると、プレビューが実際の焼き込みと違う大きさを示してしまう。
    fontSize: `${fontScale * 100}cqh`,
    color: `rgba(255,255,255,${opacity})`,
    background: boxEnabled ? `rgba(0,0,0,${boxOpacity})` : 'transparent',
    padding: boxEnabled ? '0.15em 0.3em' : 0,
    whiteSpace: 'nowrap',
    lineHeight: 1.2,
  }

  if (v === 'top') style.top = margin
  else if (v === 'bottom') style.bottom = margin
  else {
    style.top = '50%'
    style.transform = 'translateY(-50%)'
  }

  if (h === 'left') style.left = margin
  else if (h === 'right') style.right = margin
  else {
    style.left = '50%'
    style.transform = `${style.transform ?? ''} translateX(-50%)`.trim()
  }

  return (
    <div className="wm-preview" aria-label="透かしの見え方（近似）">
      {/* 明暗どちらでも読めるかを確かめられるよう、市松模様の上に載せる */}
      <div className="wm-canvas">
        {label.trim() && <span style={style}>{label}</span>}
      </div>
      <p className="muted small">
        画面上の再現です。実際の焼き込みはフォントが異なるため、字形と幅は多少変わります。
      </p>
    </div>
  )
}
